import {makeAutoObservable} from "mobx";
import {inject, injectable} from "inversify";
import {ViewController} from "data/types/structure";
import {type ILocalizationStore} from "data/stores/localization/localization.store";
import {type IModalsStore} from "data/stores/modals/modals.store";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";

export interface IModalInviteViaEmailController extends ViewController {
	i18n: ILocalizationStore;

	get isOpen(): boolean;

	close: () => void;
}

@injectable()
export class ModalInviteViaEmailController implements IModalInviteViaEmailController {
	get isOpen(): boolean {
		return this._modalsStore.modal === ModalType.INVITE_VIA_EMAIL;
	}

	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.ModalsStore) private readonly _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	close = () => {
		this._modalsStore.hideModal();
	};
}
